import { restApiMP } from "@plannel/services/utils/rest-api";

const getAll = params => {
  return restApiMP.get("/api/resource-utilization", { params });
}

const getAllForCSV = params => {
  return restApiMP.get("/api/resource-utilization/csv", { params });
}

const resourceUtilizationService = {
  getAll,
  getAllForCSV
};

export default resourceUtilizationService;